import React, { Component } from "react";
import Card from "reactstrap/lib/Card";
import CardBody from "reactstrap/lib/CardBody";
import { Header } from "@evenlogics/whf-ra-components";
import { FormGenerator } from "@evenlogics/whf-form-generator";

export default class Hotel extends Component {
  render() {
    const { id } = this.props.match.params;
    const fields = {
      title: {
        type: "text",
        label: "Title",
        required: true,
        name: "title",
        col: 12,
        disabled: true,
      },
      body: {
        type: "textarea",
        label: "Description",
        required: true,
        name: "body",
        rows:5,
        col: 12,
      },
    };

    return (
      <div>
        <Card className="animated fadeIn">
          <Header title="Employees" />
          <CardBody>
            <FormGenerator
              // targetSubmit={(values, actions, filesSet) => {
              //   alert()
              //   console.log(values, actions, filesSet);
              // }}
              targetEntity="messages"
              fields={fields}
              targetId={id}
              name="sms"
              // debug={true}
              redirect="messages/list"
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}
